module.exports = __webpack_public_path__ + "img/FW_Jk.6d856170.jpg";